import authService, { Tokens } from '@app/libs/auth/authService';

const TEMPORARY_ACCESS_TOKEN_SESSION_STORAGE_KEY = 'modusign__temporary-id-token';
const TEMPORARY_ACCESS_TOKEN_SESSION_STORAGE_REFRESH_KEY = 'modusign__temporary-id-token-second';

const documentAuthService = {
  isLinkUser() {
    return authService.hasAccessToken() && !authService.getUserUrlPaths().includes('**');
  },
  /** 로그인 계정의 token과 모바일로 요청된 문서의 token이 다를 수 있기 때문에 각 토큰을 모두 저장합니다. */
  changeTokens(linkTokens: Tokens) {
    const temporaryAccessToken = authService.getAccessToken();
    if (temporaryAccessToken) {
      window.sessionStorage.setItem(
        TEMPORARY_ACCESS_TOKEN_SESSION_STORAGE_KEY,
        temporaryAccessToken
      );
    }

    const temporaryRefreshToken = authService.getRefreshToken();
    if (temporaryRefreshToken) {
      window.sessionStorage.setItem(
        TEMPORARY_ACCESS_TOKEN_SESSION_STORAGE_REFRESH_KEY,
        temporaryRefreshToken
      );
    }
    authService.setTokens(linkTokens);
  },
  /** 문서의 token 활용이 끝나면, 로그인된 계정의 token으로 되돌립니다 */
  restoreTokens() {
    if (this.getSavedAccessToken()) {
      authService.setTokens({
        accessToken: this.getSavedAccessToken() || '',
        refreshToken: this.getSavedRefreshToken() || '',
      });
      window.sessionStorage.removeItem(TEMPORARY_ACCESS_TOKEN_SESSION_STORAGE_KEY);
      window.sessionStorage.removeItem(TEMPORARY_ACCESS_TOKEN_SESSION_STORAGE_REFRESH_KEY);
    }
  },
  getSavedAccessToken(): string | null {
    return window.sessionStorage.getItem(TEMPORARY_ACCESS_TOKEN_SESSION_STORAGE_KEY);
  },
  getSavedRefreshToken(): string | null {
    return window.sessionStorage.getItem(TEMPORARY_ACCESS_TOKEN_SESSION_STORAGE_REFRESH_KEY);
  },
  hasSavedAccessToken() {
    return !!this.getSavedAccessToken();
  },
};

export default documentAuthService;
